import babelpolyfill from "babel-polyfill";
import Vue from "vue";
import App from "./App";
import { router } from "./router";
import Element from "element-ui";
// import "./utils/rem";
import "element-ui/lib/theme-chalk/index.css";
import "./css/comm.less";
import "./css/comm.scss";
import "./css/comm.css";
import store from "./store";
import Cookies from "js-cookie";
import vuescroll from "vuescroll";
import "vuescroll/dist/vuescroll.css";
Vue.use(vuescroll);
import VueJsonp from "vue-jsonp";
Vue.use(VueJsonp);
// //富文本编辑器的导入
// import VueQuillEditor from "vue-quill-editor";
// import "quill/dist/quill.core.css";
// import "quill/dist/quill.snow.css";
// import "quill/dist/quill.bubble.css";
// Vue.use(VueQuillEditor);

// dataV
// import dataV from "@jiaminghi/data-view";
// Vue.use(dataV);

//百度地图
// import BaiduMap from "vue-baidu-map";
// Vue.use(BaiduMap, {
//   /* 申请的百度密钥，可以在百度地图官网申请 */
//   ak: "X7UHQqYy3WobTXHk3Mw3oN96ahHcQuuG",
// });
import i18n from "./lang"; // Internationalization
Vue.use(Element, {
  size: Cookies.get("size") || "mini", // set element-ui default size
  i18n: (key, value) => i18n.t(key, value),
});

// // 高德地图
// import VueAMap from "vue-amap";
// Vue.use(VueAMap);
// VueAMap.initAMapApiLoader({
//   key: "e27aa0d3e77cd014aa0a3693183542a5",
//   plugin: [
//     "AMap.DistrictSearch",
//     "AMap.Autocomplete", // 输入提示插件
//     "AMap.PlaceSearch", // POI搜索插件
//     "AMap.Scale", // 右下角缩略图插件 比例尺
//     "AMap.OverView", // 地图鹰眼插件
//     "AMap.ToolBar", // 地图工具条
//     "AMap.MapType", // 类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
//     "AMap.PolyEditor", // 编辑 折线多，边形
//     "AMap.CircleEditor", // 圆形编辑器插件
//     "AMap.Geolocation", // 定位控件，用来获取和展示用户主机所在的经纬度位置
//     "AMap.Geocoder",
//     "AMap.Icon",
//   ],
//   v: "1.4.15",
//   uiVersion: "1.0.11",
//   China: true,
// });

// 精度计算工具
import { $calc } from "./utils/precise";
Vue.prototype.$calc = $calc;

//接口导入
import api from "./api/index.js";
Vue.use(api);

new Vue({
  router,
  el: "#app",
  store,
  i18n,
  render: (h) => h(App),
});
